import(/* webpackMode: "eager" */ "/data1/service/node_modules/.pnpm/next@14.0.4_react-dom@18.2.0_react@18.2.0/node_modules/next/dist/client/script.js");
import(/* webpackMode: "eager" */ "/data1/service/src/app/normalize.css");
import(/* webpackMode: "eager" */ "/data1/service/src/app/globals.css");
import(/* webpackMode: "eager" */ "/data1/service/src/app/SEO.jsx");
import(/* webpackMode: "eager" */ "/data1/service/src/components/Global.js");
import(/* webpackMode: "eager" */ "/data1/service/src/hooks/useBackListen.js")